import { combineReducers } from 'redux';
import {
  EDIT_SUCCESS,
  EDIT_FAILURE,
  EDIT_PAYER
} from './actions';

function globalNotice(state = null, action) {
  switch (action.type) {
    case EDIT_SUCCESS:
      return {
        ...state,
        response: action.payload.response
      };
    case EDIT_PAYER:
      return {
        ...state,
        response: null
      };
    case EDIT_FAILURE:
      return {
        ...state,
        response: action.payload.response
      };
    default:
      return state;
  }
}

export default combineReducers({
  globalNotice
});
